module.exports = __webpack_public_path__ + "static/img/Eight of Wands.1d3ce11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Eight of Wands.jpg
// module id = 1264
// module chunks = 0